<template>
  <div
    v-bind:class="tileClass"
    v-bind:draggable="draggable"
    v-on:dragstart="dragstart"
    v-on:dragend="dragend"
    v-on:click="openLetterSelection"
    v-on:dblclick="moveToDraw">
    <span>{{droppedTile.value}}<span class="points">{{droppedTile.tile.point}}</span></span>
  </div>
</template>

<script>

export default {
  name: 'Tile',
  emits: ['dragstart', 'dragend', 'open-letter-selection', 'move-to-draw'],
  props: {
    droppedTile: {
      type: Object,
      required: true,
    },
    draggable: {
      type: Boolean,
      required: true,
    },
    roundNumber: {
      type: Number,
      required: true,
    },
  },
  computed: {
    tileClass() {
      return {
        tile: true,
        'flex-grow-1': true,
        'd-flex': true,
        'flex-column': true,
        'justify-content-center': true,
        'last-round': this.droppedTile.lastRound,
        wildcard: this.droppedTile.tile.value === '?',
        draggable: this.draggable,
        draging: this.draging,
      };
    },
  },
  data() {
    return {
      draging: false,
    };
  },
  beforeUnmount() {
    clearTimeout(this.dragTimer);
  },
  methods: {
    dragstart(event) {
      let from = this.$parent.$options.name;
      if (from === 'Square') {
        from = {
          square: this.$parent.square,
        };
      }
      if (from === 'GameDraw') {
        from = 'DrawSquare';
      }
      const message = {
        tile: { ...this.droppedTile },
        from,
        roundNumber: this.roundNumber,
      };
      event.dataTransfer.setData('text/plain', JSON.stringify(message));
      // La tuile glissée est masquée (.draging) et le chevalet s'ouvre : ces changements doivent suivre la
      // capture de l'image glissée par le navigateur, sinon il annule le glisser. Vue 2.5 les appliquait
      // dans une macrotâche ; Vue 3 le ferait dans une microtâche, avant cette capture, d'où le setTimeout.
      this.dragTimer = setTimeout(() => {
        this.draging = true;
        this.$emit('dragstart');
      }, 0);
    },
    dragend() {
      clearTimeout(this.dragTimer);
      this.$emit('dragend');
      this.draging = false;
    },
    openLetterSelection(event) {
      if (this.droppedTile.tile.value === '?' && this.draggable) {
        event.preventDefault();
        this.$emit('open-letter-selection', this.droppedTile);
      }
    },
    moveToDraw(event) {
      event.preventDefault();
      if (this.draggable) {
        this.$emit('move-to-draw', {
          tile: { ...this.droppedTile },
          from: {
            square: this.$parent.square,
          },
          to: 'DrawSquare',
        });
      }
    },
  },
};
</script>

<style>
.tile{
  background-color: #eecf92;
  font-family: 'Open Sans', sans-serif;
  position: relative;
  text-align: center;
  font-size: 0.8rem;
  color: #000000;
}
.tile.draggable{
  cursor: pointer;
  background-color: #ffe7b7;
}

.tile.last-round{
    background-color:#caee9b;
}
.tile.wildcard, .tile.draggable.wildcard, .tile.last-round.wildcard{
  background-color:#FFB439;
}
.tile.draging{
  display:none !important;
  margin-left:6px;
}
.tile .points{
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.5rem;
  line-height: 0.5rem;
}

@media (min-width: 992px) {
  .tile{
    font-size: 1.7rem;
    font-weight: 600;
    line-height: 1rem;
    border: 1px solid #ecdfc5;
  }
  .tile.draggable{
    border: 1px solid #898989;
  }
  .tile .points{
    right: 0px;
    bottom: 0px;
    font-size: 0.8rem;
    line-height: 0.8rem;
  }
  .tile span{
    margin-left: -3px;
    margin-top: -1px;
  }
}
</style>
